const scrollContainer = {
  padding: '0.1rem 4rem 0.1rem 0.1rem'
};

export default scrollContainer;
